import { render, staticRenderFns } from "./ItineraryStaffPickEventsSection.vue?vue&type=template&id=6ace1671&scoped=true&"
import script from "./ItineraryStaffPickEventsSection.vue?vue&type=script&lang=js&"
export * from "./ItineraryStaffPickEventsSection.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryStaffPickEventsSection.vue?vue&type=style&index=0&id=6ace1671&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ace1671",
  null
  
)

export default component.exports